<template>
  <Transition name="bounce">
    <div v-if="isShow" class="base-modal">
      <div class="base-modal__wrapper">
        <div class="base-modal__container relative">
          <div
            class="relative base-modal__content py-4 flex flex-col"
            :class="{ 'overflow-y-auto': isMobileHeight <= 500 }"
            :style="{
              minHeight: isMobile ? isMobileHeight + 'px' : 600 + 'px',
              maxHeight: isMobile ? isMobileHeight + 'px' : 600 + 'px',
            }">
            <!--Header-->
            <div class="base-modal__header d-flex flex-row no-wrap">
              <span class="base-modal__btn base-modal__btn_close text-[#A1A1AA]" @click="modalHide">Cancel</span>
              <h2 v-if="mainTitle" class="text-[16px] text-foregroundPrimary mx-auto">
                {{ !replyPostData.id ? mainTitle : 'Reply' }}
              </h2>
            </div>
            <!--Body-->
            <div class="modal-scroll-body overflow-auto px-5 pt-4" :class="{ 'min-h-[300px]': isMobileHeight <= 500 }">
              <div class="flex items-center mb-4">
                <span class="mr-2">Post as:</span>
                <Dropdown
                  class="org-drops min-w-[260px] max-w-[260px] flex items-center justify-center rounded-[10px] w-full font-bold max-h-[42px] min-h-[42px]"
                  v-model="selectedPostRole"
                  :options="postRoles"
                  optionLabel="name"
                  placeholder="Select role">
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="flex align-items-center">
                      <BaseAvatar
                        :storage-id="
                          slotProps.value.id === 1 ? userData?.avatarFile?.storageId : creatorData.avatarFile?.storageId
                        "
                        class="!max-w-[25px] !max-h-[25px] mr-2" />
                      <div class="!text-[var(--tw-text-opacity, 1)] text-[0.9rem]">
                        <span class="dropdown-menu__caption">{{
                          slotProps.value.id === 1
                            ? `${userData?.firstName}${userData?.lastName ? ` ${userData.lastName}` : ''}`
                            : creatorData.name
                        }}</span>
                      </div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                    <div class="flex align-items-center">
                      <BaseAvatar
                        :storage-id="
                          slotProps.option.id === 1
                            ? userData?.avatarFile?.storageId
                            : creatorData.avatarFile?.storageId
                        "
                        class="!max-w-[25px] !max-h-[25px] mr-2" />
                      <div class="!text-[var(--tw-text-opacity, 1)] text-[0.9rem]">
                        <span class="dropdown-menu__caption">{{
                          slotProps.option.id === 1
                            ? `${userData?.firstName}${userData?.lastName ? ` ${userData.lastName}` : ''}`
                            : creatorData.name
                        }}</span>
                      </div>
                    </div>
                  </template>
                </Dropdown>
              </div>
              <!-- <div class="d-flex items-center">
                <div class="" style="margin-right: 10px">
                  <BaseAvatar :storage-id="userData?.avatarFile?.storageId" :href="`/profile/${userData.id}`" />
                </div>
                <div class="flex justify-start items-start h-[40px]">
                  <span v-if="userData.firstName || userData.lastName" class="post__username mr-2"
                    >{{ userData?.firstName }} {{ userData?.lastName }}</span
                  >
                  <span v-if="userData.username" class="post__badge post__badge--grey mt-1">Newbie</span>
                </div>
              </div> -->
              <div class="userpost__text flex flex-col" :class="{ 'pl-[0px]': !isMobile, 'pl-0': isMobile }">
                <div class="flex flex-col" v-if="!replyPostData.id && editData?.type !== 'reply'">
                  <input
                    class="post__title"
                    @input="handleTitleInput"
                    v-model="title"
                    type="text"
                    placeholder="Add a headline (optional)..." />
                  <span class="self-end mt-[4px] mb-[24px] mr-[20px] text-[#A1A1AA] post__char-count"
                    >{{ title?.length }} / {{ maxlengthTitlePost }}</span
                  >
                </div>
                <div class="flex flex-col">
                  <editor-content :editor="editor" class="editor" />
                  <span class="self-end mr-[20px] mb-[24px] mt-[4px] text-[#A1A1AA] post__char-count"
                    >{{ text.replace(/<[^>]+>/g, '').trim().length }} / {{ maxlengthBodyPost }}</span
                  >
                </div>
              </div>
              <div v-if="loadinglinks" class="preview-link pl-[48px] mb-4">loading preview...</div>
              <div v-else class="preview-link mb-4 ml-[48px]">
                <div
                  v-if="(linksUrlImg && link?.[0]) || (linksTitle && link?.[0]) || isYoutubeVideo"
                  class="relative border-[1px] border-solid rounded-[10px] p-[20px] !border-[var(--line-decor-color)]">
                  <div
                    class="close-preview-img absolute right-4"
                    :class="{ 'top-4': !isYoutubeVideo, 'top-2': isYoutubeVideo }">
                    <div class="ml-auto mb-auto flex cursor-pointer" @click="removePreviewData">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M1.39953 13.6553L0.345703 12.6015L5.9457 7.00148L0.345703 1.40148L1.39953 0.347656L6.99953 5.94766L12.5995 0.347656L13.6534 1.40148L8.05335 7.00148L13.6534 12.6015L12.5995 13.6553L6.99953 8.05531L1.39953 13.6553Z"
                          fill="currentColor" />
                      </svg>
                    </div>
                  </div>
                  <div
                    class="post__link-preview mt-3 rounded-none !border-0 hover:bg-transparent"
                    v-if="linksTitle && link?.[0]">
                    <img
                      class="link-preview__image rounded-[10px]"
                      v-if="linksUrlImg && link?.[0]"
                      :src="linksUrlImg"
                      alt="og:image" />
                    <div
                      v-else
                      class="link-preview__image w-full h-full flex justify-center items-center rounded-[10px]">
                      <PostIcon></PostIcon>
                    </div>
                    <div class="link-preview__content text-sm">
                      <p class="link-preview__title" v-if="linksTitle && link?.[0]">{{ linksTitle }}</p>
                      <p class="link-preview__description" v-if="linksDeskription && link?.[0]">
                        {{ linksDeskription }}
                      </p>
                    </div>
                  </div>
                  <div v-if="isYoutubeVideo">
                    <iframe
                      class="post__video my-2 !min-h-[500]"
                      style="width: 100%; height: auto; aspect-ratio: 16/9"
                      :src="iframeSrc"
                      frameBorder="0"
                      scrolling="no"
                      referrerpolicy="strict-origin-when-cross-origin"
                      allowfullscreen>
                    </iframe>
                  </div>
                </div>
                <div
                  class="grid gap-4"
                  :class="
                    clsx({
                      'grid-cols-2': filesForUploading.length >= 2,
                      'grid-rows-2': filesForUploading.length === 3,
                      'h-[500px]': filesForUploading.length === 2 || filesForUploading.length === 3,
                    })
                  ">
                  <template v-if="!isLoading">
                    <MediaItem
                      v-for="(el, i) in filesForUploading"
                      :item="el"
                      :key="i"
                      :classes="filesForUploading.length === 3 && i === 0 ? 'row-span-2' : ''"
                      :isLoading="isLoading"
                      :editData="editData"
                      :BaseURL="BaseURL"
                      @remove="removeImg"
                      @addPreview="addPreview" />
                  </template>
                  <span v-else class="text-foregroundPrimary">Loading...</span>
                </div>
              </div>
              <Quote v-if="quotePostData.id" :quote="quotePostData" />

              <div>
                <div v-if="editor" class="tiptap-menu hidden">
                  <button @click="setLink" :class="{ 'is-active': editor.isActive('link') }">Set link</button>
                  <button @click="editor.chain().focus().unsetLink().run()" :disabled="!editor.isActive('link')">
                    Unset link
                  </button>
                </div>
                <ConfirmDialog group="templating" class="max-w-[500px] text-left">
                  <template #message="slotProps">
                    <div class="flex flex-col items-start">
                      <p class="mb-2">{{ slotProps.message.message }}</p>
                      <p class="text-[13px] text-[#F87171]">
                        <span class="text-[red]">!</span> Images larger than 20 MB won't be posted on X.com. Text is
                        limited to 280 characters.
                      </p>
                    </div>
                  </template>
                </ConfirmDialog>
                <ConfirmDialog group="drafts" class="confirm-drafts max-w-[500px] text-left">
                  <template #message="slotProps">
                    <div class="flex flex-col items-start">
                      <p class="confirm-drafts__text mb-2">{{ slotProps.message.message }}</p>
                      <div class="confirm-drafts__banner mb-3 flex items-center p-2">
                        <div class="confirm-drafts__text-banner">
                          <span v-if="title" class="confirm-drafts__text-banner_bold">{{ trimText(title, 10) }}</span>
                          <span v-if="text && text !== '<p></p>'" class="ml-2">{{
                            trimText(text.replace(/<[^>]+>/g, '').trim(), 30)
                          }}</span>
                          <span v-if="!title && (!text || text === '<p></p>') && filesForUploading[0]" class="ml-2"
                            >Save {{ filesForUploading.length }} image?</span
                          >
                        </div>
                      </div>
                    </div>
                  </template>
                </ConfirmDialog>
              </div>
            </div>
            <!--Footer-->
            <div class="base-modal__footer flex flex-col pl-5 pr-4">
              <div :class="{ 'mb-2': isMobile, 'mb-4': !isMobile }">
                <!-- <label v-if="!editData?.id" class="file-input-label text-[#ffffff] cursor-pointer" for="file-upload"
                      :class="{ 'pointer-events-none opacity-50': testArr[3] }"><img src="/icon/editor/photo.svg"
                                                                                      alt=""></label> -->
                <input id="file-upload" class="file-input hidden" type="file" @change="saveImage" multiple />

                <EditorToolbar
                  :isGrayActiveButton="isGrayActiveButton"
                  :editData="editData"
                  :testArr="testArr"
                  :editor="editor"
                  isOrg
                  :isShowMenuTooltip="isShowMenuTooltip"
                  @toggle-gray-active-button="toggleGrayActiveButton"
                  @upload-image="uploadImages"
                  @show-menu-tooltip="showMenuTooltip" />
              </div>

              <div
                ref="panelPost"
                class="flex items-center w-full panel-post"
                :class="{ 'justify-end -mt-[56px]': replyPostData.id, 'justify-between': !replyPostData.id }">
                <div v-if="!replyPostData.id" class="flex items-center">
                  <WeighIn />
                </div>
                <BaseButton
                  class="!max-w-[106px] !justify-center"
                  :class="{ '!bg-createPostBtnDisabledBg': disabledBtn }"
                  @click="post()"
                  :disabled="disabledBtn">
                  <div v-if="isLoadingPost" class="post__load-repost">
                    <div class="post__load-circle"></div>
                  </div>
                  <span v-else class="text-sm"> Post </span>
                </BaseButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { computed, nextTick, onBeforeUnmount, onMounted, ref, watch, watchEffect } from 'vue';

import clsx from 'clsx';
import ConfirmDialog from 'primevue/confirmdialog';
import { useConfirm } from 'primevue/useconfirm';
import { useToast } from 'primevue/usetoast';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Dropdown from 'primevue/dropdown';
import Bluesky from '@/components/Icons/Bluesky.vue';
import PostIcon from '@/components/Icons/PostIcon.vue';
import XIcon from '@/components/Icons/XIcon.vue';
import ImageWithPreview from '@/components/ImageWithPreview/ImageWithPreview.vue';
import MediaItem from '@/components/MediaItem/MediaItem.vue';
import DraftModal from '@/components/modals/saveDraftModal.vue';
import Quote from '@/components/Post/Quote.vue';
import { BaseURL } from '@/global/baseUrls.js';
import modalGetters from '@/store/modal/getters.js';
import { filterTags } from '@/utils/consts';
import suggestion from '@/utils/mentions/suggestion.js';
import { calcHeightBodyPost } from '@/utils/modalSizeUtils.js';
import { getMaxLengthChars } from '@/utils/textUtils';
import { abbreviateNumber } from '@/utils/utils.js';
import { mergeAttributes } from '@tiptap/core';
import HardBreak from '@tiptap/extension-hard-break';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import Mention from '@tiptap/extension-mention';
import Placeholder from '@tiptap/extension-placeholder';
import Strike from '@tiptap/extension-strike';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import { Editor, EditorContent, Extension, useEditor } from '@tiptap/vue-3';

import { imageGrids } from '@/utils/styles/imageGrids.js';
import { trimText } from '@/utils/textUtils';
import { validateFiles } from '@/utils/validators/files';
import EditorToolbar from '@/components/ui-kit/Toolbar/EditorToolbar.vue';

const confirm = useConfirm();
const toast = useToast();
const route = useRoute();
const router = useRouter();
const store = useStore();
const getUsernameData = username => store.dispatch('fetchUsernameData', username);
const usernameData = computed(() => store.getters.getUsernameData);
const isReplyPost = computed(() => store.getters.getIsReply);
const setPost = payload => store.dispatch('setPost', payload);
const updatePost = payload => store.dispatch('updatePost', payload);
const setDataReplyPost = post => store.dispatch('setReplyData', post);
const setDataQuotePost = post => store.dispatch('setQuoteData', post);
const setUpdateStatus = payload => store.dispatch('setUpdateStatus', payload);
const setEditData = data => store.dispatch('addModalDataToState', data);
const getUserReplies = userId => store.dispatch('setUserReplies', userId);
//const getOnlyUserPosts = (payload) => store.dispatch("setOnlyUserPosts", { id: payload, limit: "1" });
const setUpdateStatusReply = status => store.dispatch('setUpdateStatusReply', status);
const getReplies = id => store.dispatch('setRepliesPosts', id);
const getTokenBluesky = () => store.dispatch('fetchLoginBluesky');
const disconnectBluesky = () => store.dispatch('fetchDisconnectBluesky');
const isShowModal = value => store.dispatch('showOrgModal', value);
const isShowModalDraft = value => store.dispatch('showModalDraft', value);
const saveDraft = payload => store.dispatch('saveDraftPost', payload);
const editData = computed(() => store.getters.getModalData);
const isUpdateData = computed(() => store.getters.getLoadStatus);
const getShowModalStatus = computed(() => store.getters.getShowModalStatus);
const orgInfo = computed(() => store.getters.getOrgData);
const channelData = computed(() => store.getters.getChannelData);
const userdata = computed(() => store.getters.getUser);
const getUserPosts = () => store.dispatch('setUserPosts');
const getRecomendedPosts = () => store.dispatch('setRecomendedPosts');
const getDataDraftPost = computed(() => store.getters.getDataDraftPost);
const replyPostData = computed(() => store.getters.getReplyPostData);
const quotePostData = computed(() => store.getters.getQuotePostData);
const getPost = id => store.dispatch('setRecomendedPost', id);
const authWithX = () => store.dispatch('authWithX');
const isMobile = ref(window.innerWidth < 1023);
const isMobileHeight = ref(window.innerHeight - 100);
const isFirstPost = computed(() => {
  if (replyPostData?.value?.id) {
    return false;
  }
  const hasUserPosts = userdata?.value?.numPosts > 0;
  if (!hasUserPosts) {
    return true;
  }
  return false;
});

const creatorData = computed(() => {
  if (channelData.value.id) {
    return channelData.value;
  } else {
    return orgInfo.value;
  }
});

const props = defineProps({
  mainTitle: {
    type: String,
    default: '',
  },
  subTitle: {
    type: String,
    default: '',
  },
  isLogo: {
    type: Boolean,
    default: false,
  },
  isShow: {
    type: Boolean,
    default: false,
  },
  isCloseActive: {
    type: Boolean,
    default: false,
  },
  isShadow: {
    type: Boolean,
    default: false,
  },
  isSucces: {
    type: Boolean,
    default: false,
  },
  userData: {
    type: Object,
    default: '',
  },
});

const emit = defineEmits(['update:isShow']);

const disabledBtnPostX = computed(() => {
  if (
    testArr.value[0] ||
    text.value ||
    isChangeReply.value ||
    userdata.value.hasTwitterToken ||
    localStorage.getItem('isPostToX')
  ) {
    return false;
  }
  return !userdata.value?.firstName || !text.value || isLoading.value || text.value === '<p></p>';
});

const disabledBtn = computed(() => {
  const hasText = text.value?.replace(/<[^>]*>/g, '').trim().length > 0;
  if (filesForUploading.value[0] || hasText || isChangeReply.value || (isUpdateTextValue.value && hasText)) {
    return false;
  }
  return !hasText || isLoading.value;
});

const area = ref(null);
const areatext = ref('');
const result = ref(null);
const text = ref('');
const previewImages = ref([]);
const changePostToX = ref(false);
const isPostToBluesky = ref(false);
const isLoadingLinkBluesky = ref(false);
const isLoading = ref(false);
const idsImage = ref([]);
const selectedPostRole = ref({ name: 'org', id: 0 });
const link = ref(null);
const isLoadingPost = ref(false);
const isDisabledPreview = ref(false);
const isUpdateTextValue = ref(false);
const linksTitle = ref('');
const linksDeskription = ref('');
const changeReply = ref(true);
const linksUrlImg = ref('');
const mentions = ref([]);
const draftMentions = ref([]);
const title = ref('');
const badge = ref(null);
const loadinglinks = ref(false);
const isLoadingMetaData = ref(true);
const isShowMenuTooltip = ref(false);
const isChangeReply = ref(false);
const testArr = ref([]);
const rawText = ref('');
const isYoutubeVideo = ref(false);
const iframeSrc = ref('');
const iframeSrcReply = ref('');
const dynamicPadding = ref(0);
const maxlengthTitlePost = 300;
const maxlengthBodyPost = 15000;
const filesIds = ref([]);
const userId = ref(route.params.id);
const isGrayActiveButton = ref('');
const deletedLinks = ref([]);
const previousLinks = ref([]);
const displayReplyData = ref(null);

const toggleBodyScroll = isOpenModal => {
  if (isOpenModal) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }
};

const postRoles = [
  { name: 'org', id: 0 },
  { name: 'user', id: 1 },
];

watch(() => {
  toggleBodyScroll(store.getters.getShowModalStatus);
});

function updateIsMobilesize() {
  isMobile.value = window.innerWidth < 1023;
}

const TabExtension = Extension.create({
  name: 'tab',
  addKeyboardShortcuts() {
    return {
      Tab: () => {
        return this.editor.commands.insertContent('  ');
      },
    };
  },
});

const editor = useEditor({
  content: '',
  extensions: [
    StarterKit.configure({
      heading: false,
      paragraph: true,
    }),
    Strike,
    Underline,
    Link.configure({
      openOnClick: false,
      defaultProtocol: 'https',
      HTMLAttributes: {
        target: '_blank',
        rel: 'noopener noreferrer nofollow',
      },
    }),
    Placeholder.configure({
      placeholder: ({ node }) => {
        if (replyPostData.value.id) {
          return `Reply to ${
            replyPostData.value.authorUser?.username
              ? replyPostData.value.authorUser?.username
              : replyPostData.value.authorUser?.firstName + ' ' + replyPostData.value.authorUser?.lastName
          }...`;
        } else {
          return "What's on your mind?";
        }
      },
    }),
    TextAlign.configure({
      types: ['heading', 'paragraph'],
    }),
    HardBreak,
    TabExtension,
    Mention.configure({
      HTMLAttributes: {
        class: 'mention',
        dataId: 'f',
      },
      suggestion,
      renderHTML({ options, node }) {
        const user = node.attrs.id;
        mentions.value.push({ userId: user.id, text: user.username });
        return ['a', mergeAttributes({ href: `/user/${user.username}` }), `@${user.username}`];
      },
    }),
  ],
  onUpdate({ editor }) {
    if (text.value === '<p></p>' || text.value === '') {
      mentions.value = [];
      isUpdateTextValue.value = false;
    }
    let content = editor.getHTML();
    let plainText = content.replace(/<[^>]+>/g, '').trim();

    // Проверяем удаленные ссылки
    let reg = /(?<!href\s*=\s*["']?)(?<!src\s*=\s*["']?)(https?:\/\/[^\s<]+)/gi;
    const currentLinks = content.match(reg) || [];

    if (previousLinks.value.length > 0) {
      const deletedUrls = previousLinks.value.filter(link => !currentLinks.includes(link));
      deletedLinks.value = deletedLinks.value.filter(link => !deletedUrls.includes(link));
    }
    previousLinks.value = currentLinks;

    content = content.replace(/<p><\/p>/g, '<p><br></p>');

    const { from } = editor.state.selection;
    const currentWord =
      editor.state.doc
        .textBetween(Math.max(0, from - 1000), from)
        .split(/\s/)
        .pop() || '';

    // Проверяем только текущее слово на соответствие формату ссылки
    const isCurrentWordLink = reg.test(currentWord);

    if (!isDisabledPreview.value && isCurrentWordLink) {
      handlerLinksPreview(content);
    }

    if (plainText.length > maxlengthBodyPost) {
      const trimmedText = plainText.slice(0, maxlengthBodyPost);
      editor.commands.setContent(trimmedText);
      text.value = trimmedText;
    } else {
      text.value = content;
    }
  },
});

const getYoutubeEmbedUrl = url => {
  if (url.includes('youtube.com/shorts')) {
    return `https://www.youtube.com/embed/${url.split('/shorts/')[1].split('?')[0]}`;
  }
  if (url.includes('youtube.com/watch')) {
    return `https://www.youtube.com/embed/${url.split('v=')[1].split('&')[0]}`;
  }
  if (url.includes('youtu.be')) {
    return `https://www.youtube.com/embed/${url.split('/')[3].split('?')[0]}`;
  }
  return null;
};

const handlerLinksPreview = async text => {
  let reg = /(?<!href\s*=\s*["']?)(?<!src\s*=\s*["']?)(https?:\/\/[^\s<]+)/gi;
  const allLinks = text.match(reg) || [];

  // if(allLinks.find(link => !link.value.includes(link))) {
  //   return;
  // }

  const foundLink = allLinks.find(link => !deletedLinks.value.includes(link));

  if (foundLink) {
    link.value = [foundLink];
    const embedUrl = getYoutubeEmbedUrl(foundLink);
    if (embedUrl) {
      isYoutubeVideo.value = true;
      iframeSrc.value = embedUrl;
      linksTitle.value = '';
      linksDeskription.value = '';
    } else {
      loadinglinks.value = true;
      await fetchUrlPreview(foundLink);
    }
  }
};

const handlerLinksPreviewReply = async text => {
  let reg = /(?<!href\s*=\s*["']?)(?<!src\s*=\s*["']?)(https?:\/\/[^\s<]+)/gi;
  const uniqueLinks = [...new Set(text.match(reg))];
  if (uniqueLinks?.[0]) {
    const embedUrl = getYoutubeEmbedUrl(uniqueLinks[0]);
    if (embedUrl) {
      iframeSrcReply.value = embedUrl;
      displayReplyData.value = {
        ...replyPostData.value,
        urls: [
          {
            url: uniqueLinks[0],
          },
        ],
      };
    }
  }
};

const fetchUrlPreview = async url => {
  try {
    const response = await fetch(`/api/url-preview`, {
      method: 'POST',
      body: JSON.stringify({ url }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const data = await response.json();
    if (data && (data.title || data.description || data.imageUrl)) {
      linksTitle.value = data.title;
      linksDeskription.value = data.description;
      linksUrlImg.value = data.imageUrl;
    } else {
      link.value = [];
    }
  } catch (error) {
    console.error('Error fetching URL preview:', error.message);
  } finally {
    loadinglinks.value = false;
  }
};

watch(
  () => route.params.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      selectedPostRole.value = { name: 'org', id: 0 };
    }
  },
);

onMounted(async () => {
  updateHegth();
  calculateContentPaddingLeft();
  addEventListener('resize', event => {
    updateHegth();
  });
  window.addEventListener('resize', updateIsMobilesize);
  setTimeout(() => {
    const editorElement = document.getElementsByClassName('ProseMirror')[0];
    if (editorElement) {
      const initialText = editorElement.innerHTML.replace(/<[^>]+>/g, '').trim();
      text.value = initialText;
    }
  }, 200);
});

onBeforeUnmount(() => {
  editor.value.destroy();
  window.removeEventListener('resize', updateIsMobilesize);
  window.removeEventListener('resize', updateHegth);
});

const checkPostToX = () => {
  if (!changePostToX.value) {
    localStorage.setItem('isPostToX', false);
  }
};

const changePostToBluesky = async () => {
  if (isPostToBluesky.value) {
    isLoadingLinkBluesky.value = true;
    let res = await getTokenBluesky();
    if (!res?.statusCode) {
      isLoadingLinkBluesky.value = false;
      document.location.href = res.url;
    } else {
      toast.add({
        severity: 'error',
        detail: res.message,
        life: 3000,
      });
      isLoadingLinkBluesky.value = false;
    }
  } else {
    isLoadingLinkBluesky.value = true;
    let res = await disconnectBluesky();
    if (!res?.statusCode) {
      toast.add({
        severity: 'success',
        summary: 'Bluesky Account Disconnected',
        detail: 'Your Bluesky account has been disconnected. Posts will no longer be published to Bluesky.',
        life: 3000,
      });
      localStorage.removeItem('isPostToBluesky');
    } else {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: res.message,
        life: 3000,
      });
    }
    isLoadingLinkBluesky.value = false;
  }
};

const updateHegth = () => {
  isMobileHeight.value = window.innerHeight > 550 ? window.innerHeight - 80 : window.innerHeight;
};

const showConfirmX = () => {
  confirm.require({
    group: 'templating',
    header: 'Post to X',
    message: 'You will need to be authorized through X to post it.',
    acceptLabel: 'Ok',
    rejectLabel: 'Cancel',
    accept: () => {
      changePostToX.value = true;
      if (title.value) {
        localStorage.setItem('saveTitle', title.value);
      }
      localStorage.setItem('saveText', text.value);
      authWithX();
    },
    reject: () => {
      changePostToX.value = false;
      localStorage.setItem('isPostToX', false);
    },
  });
};

const showSaveDraftConfirm = async () => {
  if ((!text.value || text.value === '<p></p>') && !filesForUploading.value[0]) {
    isShowModalDraft(true);
  } else {
    let data = await uploadImages();
    data = data.filter(el => el !== undefined);
    if (data[0]) {
      filesIds.value = Array.from(filesIds.value[0] ? [...filesIds.value, ...data] : [...data]);
    }
    let payload = {
      text: text.value,
      title: title.value ? title.value : undefined,
      rawText: rawText.value !== '' ? rawText.value : undefined,
      attachedFilesIds: filesIds.value ? filesIds.value : undefined,
      urls: link?.value?.[0]
        ? [
            {
              url: link?.value?.[0],
              title: linksTitle?.value,
              description: linksDeskription?.value,
              imageUrl: linksUrlImg?.value,
            },
          ]
        : undefined,
      mentions: mentions.value[0] || draftMentions.value[0] ? [...mentions.value, ...draftMentions.value] : undefined,
    };
    confirm.require({
      group: 'drafts',
      header: 'Save post as draft?',
      message: "You've started creating a post. Do you want to save it as a draft to finish and post later?",
      acceptLabel: 'Save',
      rejectLabel: 'Cancel',
      accept: async () => {
        let res = await saveDraft(payload);
        if (res?.ok) {
          toast.add({
            severity: 'success',
            summary: 'Draft saved',
            detail: 'Your draft has been successfully saved.',
            life: 3000,
          });
        } else {
          if (res) {
            let data = await res?.json();
            toast.add({
              severity: 'error',
              summary: 'Error',
              detail: data?.message[0],
              life: 3000,
            });
          } else {
            toast.add({
              severity: 'error',
              summary: 'Unable to save draft',
              detail: "Drafts with @‌mentions aren't supported right now. Please try again later.",
              life: 5000,
            });
          }
        }
      },
      reject: () => {
        isShowModalDraft(true);
      },
    });
  }
};

const setLink = () => {
  const previousUrl = editor.value.getAttributes('link').href;
  const url = window.prompt('URL', previousUrl);
  // cancelled
  if (url === null) {
    return;
  }
  // empty
  if (url === '') {
    editor.value.chain().focus().extendMarkRange('link').unsetLink().run();
    return;
  }
  // update link
  editor.value.chain().focus().extendMarkRange('link').setLink({ href: url }).run();
};

const closeLinkPreview = () => {
  link.value[0] = null;
  linksTitle.value = null;
  linksDeskription.value = null;
  linksUrlImg.value = null;
  areatext.value = '';
};

const calculateContentPaddingLeft = () => {
  if (badge.value) {
    const badgeWidth = badge.value.offsetWidth;
    dynamicPadding.value = (badgeWidth * 3) / 2;
  }
};

const showMenuTooltip = () => {
  isShowMenuTooltip.value = !isShowMenuTooltip.value;
};

const removePreviewData = () => {
  if (link.value?.[0]) {
    deletedLinks.value.push(link.value[0]);
  }
  link.value = null;
  linksUrlImg.value = null;
  linksTitle.value = null;
  linksDeskription.value = null;
  link.value = [];
  isYoutubeVideo.value = false;
  iframeSrc.value = '';
};

const modalHide = () => {
  setDataReplyPost({});
  setDataQuotePost({});
  cleanFields();
  isShowModal(false);
  setEditData(null);
  isLoading.value = false;
  document.body.style.overflow = 'auto';
  localStorage.removeItem('saveText');
  localStorage.removeItem('saveTitle');
  iframeSrcReply.value = '';
  deletedLinks.value = [];
  link.value = [];

  linksTitle.value = null;
  linksDeskription.value = null;
  linksUrlImg.value = null;
  isYoutubeVideo.value = false;
  text.value = '';
};

const resolveUserId = async () => {
  if (!route.params.username) {
    return route.params.id;
  }
  await getUsernameData(route.params.username);
  return usernameData.value?.id || null;
};

// const showUserPosts = async () => {
//   const id = userId ? userId : await resolveUserId();
//   //getOnlyUserPosts(id);
// }

const cleanFields = () => {
  filesIds.value = [];
  filesForUploading.value = [];
  text.value = '';
  title.value = '';
  mentions.value = [];
  draftMentions.value = [];
  editor.value.commands.clearContent(true);
};

const removeImg = id => {
  filesForUploading.value = filesForUploading.value.filter(item => item.id !== id);
  filesIds.value = filesIds.value.filter(item => item !== id);
  // previewImages.value.pop();
};

const addPreview = updatedItem => {
  filesForUploading.value = filesForUploading.value.map(item =>
    item.id === updatedItem.id ? { ...item, preview: updatedItem.preview, previewFile: updatedItem.previewFile } : item,
  );
};

const processTagsInPost = text => {
  const tags = [];
  const cleanText = text.replace(/#(\w+)/g, (match, tag) => {
    const foundTag = filterTags.find(ft => ft.label.toLowerCase() === tag.toLowerCase());

    if (foundTag) {
      tags.push(foundTag.label);
      return '';
    }

    return match;
  });

  return {
    cleanText: cleanText.replace(/\s+/g, ' ').trim(),
    tags,
  };
};

const post = async () => {
  const { cleanText, tags } = processTagsInPost(text.value);

  text.value = cleanText;

  mentions.value = mentions.value.filter((obj, idx, arr) => idx === arr.findIndex(t => t.userId === obj.userId));
  isLoading.value = true;
  if (!editData.value?.id) {
    let data = await uploadImages();
    data = data.filter(el => el !== undefined);
    if (data[0]) {
      filesIds.value = filesIds.value[0] ? [...filesIds.value, ...data] : [...data];
    }
  }
  const thresholds = await JSON.parse(localStorage.getItem('thresholdsPost'));
  if (changePostToX.value || isPostToBluesky.value) {
    rawText.value = text.value.replace(/<.*?>/g, ' ').slice(0, 279);
    rawText.value = `${title.value} ${rawText.value}`;
  }
  testArr.value.forEach(item => {
    idsImage.value.push(item.id);
  });
  const textObj = text.value ? { text: text.value } : {};
  const isQuote = !!quotePostData.value?.id;
  let payload = {
    ...textObj,
    title: title.value ? title.value : undefined,
    rawText: rawText.value !== '' ? rawText.value : undefined,
    id: editData.value ? editData.value.id : undefined,
    attachedFileIds: filesIds.value || undefined,
    isAnyoneCanReply: changeReply.value,
    // repostedPostId: reply?.id,
    postToTwitter: false,
    postToBluesky: false,
    channelId: creatorData.value.id,
    displayedChannelId: selectedPostRole.value.id === 0 ? null : userdata.value.channel.id,
    weighInThresholds: thresholds ? thresholds : undefined,
    urls:
      link?.value?.[0] && !isDisabledPreview.value
        ? [
            {
              url: link?.value?.[0],
              title: linksTitle?.value,
              description: linksDeskription?.value,
              imageUrl: linksUrlImg?.value,
            },
          ]
        : undefined,
    mentions: mentions.value[0] || draftMentions.value[0] ? [...mentions.value, ...draftMentions.value] : undefined,
    ...(isQuote ? { isComment: false } : {}),
    toast,
    tags: editData.value && editData.value.tags ? [...editData.value.tags, ...tags] : tags,
  };
  if (false) {
    if (title.value === '') {
      payload.title === null;
    }
    isLoadingPost.value = true;
    await updatePost(payload);
    isLoadingPost.value = false;
    if (route.name === 'post' && !isReplyPost) {
      await getPost(editData.value.id);
    }
    if (route.name === 'profile' || route.name === 'username') {
      await getUserReplies(editData.value.authorUserId);
      //await getOnlyUserPosts(editData.value.authorUserId);
      isLoading.value = false;
    }
    setEditData(null);
    modalHide();
  } else {
    isLoadingPost.value = true;
    setUpdateStatus(true);
    const res = await setPost(payload);
    if (res?.ok) {
      // setUpdateStatusReply(reply);
      // if (reply.isMainPost) {
      //   getReplies(reply.id);
      // }
      cleanFields();
      document.body.style.overflow = 'auto';
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
      modalHide();
      setTimeout(() => {
        setUpdateStatusReply([]);
      }, 100);
      isLoadingPost.value = false;
      setUpdateStatus(false);
    } else {
      if (!isPostToBluesky.value) {
        modalHide();
      }
      isLoadingPost.value = false;
    }
  }
  deletedLinks.value = [];
  text.value = '';
};

const validatePost = computed(() => {
  return true;
});

const filesForUploading = ref([]);

const uploadImages = async () => {
  async function getPreviews() {
    const uploadPromises = filesForUploading.value.slice(0, 4).map(async item => {
      if (item.previewFile) {
        const formData = new FormData();
        formData.append('file', item.previewFile);

        try {
          const response = await fetch(`/api/files`, {
            method: 'POST',
            body: formData,
          });
          if (!response.ok) throw new Error('Upload failed');
          const res = await response.json();
          return await uploadFile(item.file, res.id);
        } catch (error) {
          console.log('Upload error:', error);
          return null;
        }
      } else {
        return await uploadFile(item.file);
      }
    });

    return (await Promise.all(uploadPromises)).filter(result => result !== null);
  }

  async function uploadFile(file, previewFileId) {
    if (file) {
      const formData = new FormData();
      formData.append('file', file);
      if (previewFileId) {
        formData.append('previewFileId', previewFileId);
      }
      const response = await fetch(`/api/files`, {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) throw new Error('Upload failed');
      return await response.json();
    }
  }

  const previews = await getPreviews();
  return previews.map(el => el?.id);
};

const saveImage = async e => {
  const files = e.target.files;
  const validationErrors = await validateFiles(files);
  if (validationErrors.length > 0) {
    const message = validationErrors.join('\n');
    toast.add({
      severity: 'error',
      summary: message,
      life: 7000,
    });
    return;
  }

  isLoading.value = true;
  Object.values(files).forEach((item, i, arr) => {
    const reader = new FileReader();
    reader.readAsDataURL(item);

    const fileType = item.type.startsWith('video') ? 'video' : 'image';

    reader.onload = e => {
      filesForUploading.value.push({
        preview: '',
        isLoading: false,
        editData: false,
        BaseURL: '',
        id: Date.now().toString() + Math.random().toString(36).substr(2, 9),
        type: fileType, // <-- Set type based on file type
        isEdit: false,
        file: item,
        image: e.target.result,
      });
    };
  });
  isLoading.value = false;
};

// Счёт кол-во введённых символов и ограничение его
const handleTitleInput = event => {
  if (editData.value && event.target.value !== editData.value.title) {
    isUpdateTextValue.value = true;
  }
  title.value = getMaxLengthChars(title.value, maxlengthTitlePost);
};

const toggleGrayActiveButton = active => (isGrayActiveButton.value = active);
</script>

<style lang="scss">
.base-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;

  &__wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  &__header {
    width: 100%;
    border-color: #fff;
    border-bottom: 1px solid var(--line-decor-color);
    padding-bottom: 15px;
  }

  &__container {
    max-width: 800px;
    min-height: 600px;
    margin: 0 auto;
    background: var(--background-primary);
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
  }

  &__banner {
    border-radius: 16px 0px 0px 16px;
  }

  &__body {
    margin-bottom: 45px;
    padding: 10px 20px;
    max-height: 600px;
    // min-height: 420px;
    overflow-y: scroll;
  }

  &__footer {
    display: flex;
    justify-content: center;
  }

  &__btn {
    position: absolute;
    top: 18px;
    width: 26px;
    height: 26px;
    cursor: pointer;
    transition: opacity ease 0.5s;

    &_drafts {
      right: 40px;
    }

    &_close {
      left: 20px;
    }
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;

    .header {
      &__logo-link {
        display: inline-block;
        text-decoration: none;
        margin-bottom: 10px;
      }

      &__logo-img {
        min-width: 88px;
        height: 88px;
      }

      @keyframes l {
        to {
          clip-path: inset(0 -1ch 0 0);
        }
      }
    }
  }

  @include _1024 {
    &__wrapper {
      padding: 0;
      height: 100%;
      max-width: 100vw;
    }

    &__container {
      max-width: 100%;
      min-height: 100%;
    }

    &__body {
      width: 100%;
      margin-bottom: 20px;
      // min-height: 300px;
      height: 100%;
    }

    &__footer {
      width: 100%;
    }
  }

  @media (max-width: 640px) {
    &__wrapper {
      padding-bottom: 60px;
    }
  }

  @include _380 {
    &__container {
      padding: 30px 0;
    }
  }
}

.bounce-enter-active {
  animation: bounce-in 0.5s ease-out;
}

.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}

@keyframes bounce-in {
  0% {
    transform: translateY(-100%);
  }

  30% {
    transform: translateY(5%);
  }

  65% {
    transform: translateY(-2%);
  }

  100% {
    transform: translateY(0%);
  }
}

.modal-scroll-body {
  flex-grow: 1;
  scrollbar-width: thin;
  /* "auto" or "thin" */
  scrollbar-color: var(--scrollbar-track-color) var(--scrollbar-bg);
  /* scroll thumb and track */
}

.modal-scroll-body::-webkit-scrollbar {
  width: 5px;
  /* width of the entire scrollbar */
}

.modal-scroll-body::-webkit-scrollbar-track {
  background: var(--scrollbar-bg);
  /* color of the tracking area */
}

.modal-scroll-body::-webkit-scrollbar-thumb {
  background-color: var(--scrollbar-track-color);
  /* color of the scroll thumb */
  border-radius: 20px;
  /* roundness of the scroll thumb */
  border: 2px solid var(--scrollbar-bg);
  /* creates padding around scroll thumb */
}

.base-modal__body {
  max-height: 100% !important;
  overflow: unset !important;
}

body {
  color: #f2f2f2;
}

.uploading-image {
  width: 100%;
  height: 100%;
  margin-bottom: 10px;
  border-radius: 8px;
  max-height: 520px;
  object-fit: cover;
  object-position: center;
}

.editor {
  width: 97%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  caret-color: var(--foreground-primary);

  &::-webkit-scrollbar {
    display: none;
  }

  .ProseMirror {
    outline: none;
  }
}

.editor .tiptap {
  margin-top: 0;
  padding-left: 0;
  border: none;
  background: transparent;
}

.editor .ProseMirror-focused {
  border: transparent;
  outline: none;
}

.editor .ProseMirror-trailingBreak {
  color: #f2f2f2;
}

.editor .tiptap p.is-editor-empty:first-child::before {
  color: #52525b;
  font-size: 16px;
  content: attr(data-placeholder);
  float: left;
  height: 0;
  pointer-events: none;
}

.editor .tiptap p {
  display: block;
  color: var(--foreground-primary);
  font-size: 16px;
}

.tiptap {
  border: 2px solid rgb(216, 180, 254);
  border-radius: 10px;
  padding: 15px;
  margin-top: 10px;
  color: #0d0d0d;
  background: #f2f2f2;

  > * + * {
    margin-top: 0.75em;
  }

  hr {
    background: rgb(216, 180, 254);
    margin: 0;
  }

  blockquote {
    border-left: 1px rgb(216, 180, 254);
  }

  .mention {
    border-radius: 0.4rem;
    box-decoration-break: clone;
    background-color: transparent !important;
    color: #a78bfa !important;
    padding: 0.1rem 0.3rem;
    font-size: 16px !important;
  }

  a {
    color: #a78bfa;
    font-family: $protext;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.02px;
  }

  ul,
  ol {
    padding: 0 1rem 0 1.5rem;
    color: var(--foreground-primary);

    li::marker {
      margin-right: 2px !important;
    }
  }

  h1 {
    font-size: 32px;
  }

  h2 {
    font-size: 28px;
  }

  h3 {
    font-size: 24px;
  }

  h4 {
    font-size: 18px;
  }

  h5 {
    font-size: 16px;
  }

  h6 {
    font-size: 14px;
  }

  code {
    background: green;
    border-radius: 10px;
    padding: 2px 10px;
    color: #fff;
    font-size: 14px;
    margin: 0 5px;
  }

  pre {
    background: #0d0d0d;
    color: #fff;
    padding: 0.75rem 1rem;
    border-radius: 0.5rem;

    code {
      color: inherit;
      padding: 0;
      background: none;
      font-size: 0.8rem;
    }
  }

  img {
    max-width: 100%;
    height: auto;
  }

  blockquote {
    padding-left: 1rem;
    border-left: 2px solid rgba(#0d0d0d, 0.1);
  }

  hr {
    border: none;
    border-top: 2px solid rgba(#0d0d0d, 0.1);
    margin: 2rem 0;
  }
}

.editor-buttons-set {
  width: 20%;
  display: flex;
  flex-direction: row;
  margin-right: 10px;
}

.post__badge {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 4px;
  height: 16px;
  border-radius: 50px;
  font-size: 11px;
  line-height: 14px;
  font-weight: 500;
}

.post__badge--grey {
  padding: 6px 3px;
  background-color: var(--post-badge-bg);
  color: var(--post-badge-text-color);
}

.post__username {
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  color: var(--foreground-primary);
}

// .post__title {
//   padding: 15px 15px 15px 0;
// }

.userpost__text {
  & input {
    position: relative;
    width: 100%;
    border: none;
    background: transparent;
    color: var(--foreground-primary);
    font-size: 18px;
    caret-color: var(--foreground-primary);

    &::placeholder {
      color: #52525b;
      font-size: 18px;
    }
  }

  & textarea {
    position: relative;
    width: 100%;
    border: none;
    background: transparent;
    color: var(--foreground-primary);
    font-size: 14px;
    min-height: 50px;
    caret-color: var(--foreground-primary);

    &::placeholder {
      color: #52525b;
      font-size: 14px;
    }
  }
}

.editor-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--background-btn-secondary);
  width: 91.5px;
  height: 40px;
  cursor: pointer;

  &__left {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }

  &__right {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  &.is-active__green {
    background: var(--background-editor-btn-green);
  }

  &.is-active__grey {
    background: #27272a;
  }
}

.p-dialog-header-close {
  display: none !important;
}

.p-dialog-header {
  background: var(--p-dialog-bg);
  color: var(--foreground-primary);
}

.p-dialog-content {
  background: var(--p-dialog-bg);
  color: var(--foreground-primary);
}

.p-dialog-footer {
  background: var(--p-dialog-bg);
  color: var(--foreground-primary);
}

.p-dialog {
  background: var(--p-dialog-bg);
  color: var(--foreground-primary);
  border: none;
}

.p-confirm-dialog-accept {
  margin-right: 10px;
  padding: 5px 10px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #a3e635;
  color: #09090b;
  border-radius: 8px;
  min-width: 90px;
  max-height: 40px;
  height: 44px;
  font-size: 16px;
}

.p-confirm-dialog-reject {
  margin-right: 10px;
  padding: 5px 10px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: var(--background-secondary);
  color: var(--foreground-primary);
  min-width: 90px;
  max-height: 40px;
  height: 44px;
  font-size: 16px;
}

.panel-editor-battons {
  gap: 10px;
  padding: 6px 12px;
  border: 1.5px solid #313030;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: none;
  background-color: var(--background-secondary);
  z-index: 10;
}

.post__load {
  &-repost {
    width: 25px;
    height: 25px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
  }

  &-circle {
    position: absolute;
    width: 14px;
    height: 14px;
    border: 1px solid rgba(0, 0, 0, 1);
    border-radius: 50%;
    border-left-color: transparent;
    border-right-color: transparent;
    animation: cssload-spin 575ms infinite linear;
    -o-animation: cssload-spin 575ms infinite linear;
    -ms-animation: cssload-spin 575ms infinite linear;
    -webkit-animation: cssload-spin 575ms infinite linear;
    -moz-animation: cssload-spin 575ms infinite linear;
    box-sizing: border-box;

    @keyframes cssload-spin {
      100% {
        transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-o-keyframes cssload-spin {
      100% {
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-ms-keyframes cssload-spin {
      100% {
        -ms-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-webkit-keyframes cssload-spin {
      100% {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }

    @-moz-keyframes cssload-spin {
      100% {
        -moz-transform: rotate(360deg);
        transform: rotate(360deg);
      }
    }
  }
}

.reply-box {
  position: relative;
  min-height: 120px;
  width: 100%;
  padding-left: 60px;

  &::before {
    content: '';
    position: absolute;
    left: 18px;
    top: 45px;
    width: 4px;
    height: 95.73%;
    background: var(--reply-line-color);
    z-index: 0;
  }

  @media (max-width: 1024px) {
    padding-top: 20px;
  }
}

//drafts
.confirm-drafts .p-dialog {
  background: var(--foreground-primary);
}

.confirm-drafts .p-dialog-header {
  padding: 10px;
  gap: 0;
}

.confirm-drafts .p-dialog-content {
  padding: 10px;
  gap: 0;
}

.confirm-drafts .p-dialog-footer {
  padding: 0;
  gap: 0;
}

.confirm-drafts .p-dialog-header-close {
  display: block !important;
  color: var(--foreground-primary);
}

.confirm-drafts .p-dialog-title {
  font-size: 20px;
  color: var(--foreground-primary);
  font-weight: 400;
}

.confirm-drafts__text {
  font-size: 14px;
  color: var(--foreground-secondary);
}

.confirm-drafts__banner {
  width: 100%;
  height: 51px;
  background: var(--background-secondary);
}

.confirm-drafts__text-banner {
  font-size: 18px;
  color: var(--foreground-primary);
  font-weight: 400;

  &_bold {
    font-weight: bold;
  }
}

.confirm-drafts .p-confirm-dialog-accept {
  width: 100%;
  margin: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background: #a3e635;
  color: #09090b;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 10px;
  height: 44px;
  font-size: 16px;
}

.confirm-drafts .p-confirm-dialog-reject {
  width: 100%;
  margin: 0;
  border-radius: 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 0px;
  background: var(--background-secondary);
  color: var(--foreground-primary);
  height: 44px;
  font-size: 16px;
}

.p-dropdown {
  padding: 5px !important;
  background: var(--background-secondary) !important;
  border: none !important;
}
.org-drops.p-dropdown {
  background: var(--post-button-bg) !important;
}
.p-inputwrapper-focus {
  border: none !important;
}
.p-dropdown span {
  color: var(--foreground-primary) !important;
  font-size: 14px !important;
}
.p-dropdown div {
  color: var(--foreground-primary) !important;
}
.p-dropdown-panel .p-component {
  background: var(--background-secondary) !important;
}
.p-inputwrapper-focus {
  border: none !important;
}
.p-dropdown-panel {
  background: var(--background-secondary) !important;
  color: var(--foreground-primary) !important;
  font-size: 14px;
  border: none !important;
}
.p-dropdown:focus-within {
  border: none !important;
  border-bottom: 1px solid #e4e4e7 !important;
}
.base-modal__body.p-component:focus-within {
  border: none !important;
  border-bottom: 1px solid #e4e4e7 !important;
}
.p-dropdown:not(.p-disabled).p-focus {
  border: none !important;
  border-color: transparent;
}
.p-focus {
  background: var(--background-primary) !important;
  color: var(--foreground-primary) !important;
  border: none !important;
}
.p-highlight {
  background: var(--background-primary) !important;
  color: var(--foreground-primary) !important;
}
.p-dropdown-item {
  color: var(--foreground-primary) !important;
  font-size: 14px;
}
.p-inputwrapper-filled {
  border: none !important;
}
.p-inputwrapper-focus {
  border: none !important;
}
</style>
